module.exports = __webpack_public_path__ + "static/media/checkmark.2455225f.svg";